import { compose } from 'recompose'
import Login from './presenter'

export default compose()( Login )